/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_PrivateInputs */

const en_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft / Private`)
};

const es_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrador / Privado`)
};

const fr_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon / Privé`)
};

const de_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf / Privat`)
};

const ja_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書き / 非公開`)
};

const zh_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿 / 私密`)
};

const ar_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسودة / خاص`)
};

const id_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf / Pribadi`)
};

const it_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza / Privato`)
};

const ru_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черновик / Приватный`)
};

const pt_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho / Privado`)
};

const ko_draft_private = /** @type {(inputs: Draft_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임시저장 / 비공개`)
};

/**
* | output |
* | --- |
* | "Draft / Private" |
*
* @param {Draft_PrivateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const draft_private = /** @type {((inputs?: Draft_PrivateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_PrivateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_private(inputs)
	if (locale === "es") return es_draft_private(inputs)
	if (locale === "fr") return fr_draft_private(inputs)
	if (locale === "de") return de_draft_private(inputs)
	if (locale === "ja") return ja_draft_private(inputs)
	if (locale === "zh") return zh_draft_private(inputs)
	if (locale === "ar") return ar_draft_private(inputs)
	if (locale === "id") return id_draft_private(inputs)
	if (locale === "it") return it_draft_private(inputs)
	if (locale === "ru") return ru_draft_private(inputs)
	if (locale === "pt") return pt_draft_private(inputs)
	return ko_draft_private(inputs)
});